import DefaultIcon from '../../assets/images/default icon.png';

// Define require.context for each image type directory
// Adjust the path ('../../assets/images') and regex if your structure is different
const transportProviderContext = require.context(
  '../../assets/images/transportProvider',
  false, // Do not search subdirectories
  /\.(png|jpe?g|svg|webp)$/ // Regex for image file extensions
);

const sensorImagesContext = require.context(
  '../../assets/images/SensorImages',
  false,
  /\.(png|jpe?g|svg|webp)$/
);

const supportedExtensions = ['svg', 'png', 'jpg', 'jpeg', 'webp'];

/**
 * Finds the correct image path for a given provider/sensor name and type using require.context.
 * Handles special cases and falls back to a default icon.
 *
 * @param {string} name - The name of the provider or sensor.
 * @param {'transportProvider' | 'SensorImages'} type - The type of image folder to look in.
 * @returns {string} The path to the image or the default icon path.
 */
export const getProviderImagePath = (name, type) => {
  if (!name || !type) {
    return DefaultIcon;
  }

  let imageFileName = name;
  let requireContext;

  // Select the correct context and handle special file names
  if (type === 'transportProvider') {
    requireContext = transportProviderContext;
    if (name === 'Time:Matters') {
      imageFileName = 'time-matters';
    }
    // Add other special cases for transport providers here
  } else if (type === 'SensorImages') {
    requireContext = sensorImagesContext;
    // Add special cases for sensors here if needed
    // Example: if (name === 'Some Sensor Name') { imageFileName = 'some-sensor-name'; }
  } else {
    return DefaultIcon; // Invalid type
  }

  let imagePath = null;

  // Try finding the image with supported extensions
  for (const ext of supportedExtensions) {
    try {
      // Construct the relative path expected by require.context (e.g., './FedEx.png')
      const potentialPath = `./${imageFileName}.${ext}`;
      // Check if the context knows about this file and require it
      if (requireContext.keys().includes(potentialPath)) {
        imagePath = requireContext(potentialPath);
        break; // Found the image
      }
    } catch (error) {
      // Log error or handle cases where requireContext might fail unexpectedly
      console.error(`Error requiring image: ${imageFileName}.${ext}`, error);
    }
  }

  // Fallback to default icon if no specific image was found
  if (!imagePath) {
    return DefaultIcon;
  }

  // Handle cases where require.context might return a module object
  return typeof imagePath === 'object' && imagePath.default ? imagePath.default : imagePath;
};

// Example of how you might need to handle require context in Webpack:
// const requireContext = require.context('../../assets/images/', true, /\.(png|jpe?g|svg|webp)$/);
// export const getProviderImagePathWebpack = (name, type) => {
//   // ... logic to determine imageFileName ...
//   const pathAttempt = `./${type}/${imageFileName}`;
//   let imagePath = DefaultIcon; // Start with default

//   supportedExtensions.forEach(ext => {
//     try {
//       const potentialPath = `${pathAttempt}.${ext}`;
//       // Check if the path exists in the context
//       if (requireContext.keys().includes(potentialPath.replace('./', ''))) {
//          imagePath = requireContext(potentialPath);
//          return; // Exit loop early if found
//       }
//     } catch (e) { /* ignore */ }
//   });
//   return typeof imagePath === 'object' && imagePath.default ? imagePath.default : imagePath;
// }

// Helper function to add index file for utils
export const addIndexFile = () => {
 console.log("Remember to export utilities from src/common/utils/index.js if needed");
} 